import React, { useEffect } from "react";
import styled from "styled-components";
import Button from "../Button";
import FilterToggleControl from "../controls/FilterToggleControl";

const FilterControls = ({ 
  items, 
  setFilteredItems, 
  activeFilters, 
  setActiveFilters, 
  defaultActiveFilters, 
  filtersOpenMobile, 
  setFiltersOpenMobile, 
  entity, 
  filteredItems, 
  filterSections,
  filterTypeLabel,
  operatorType = "and",
  hasMobileNav = false
}) => {

  function handleFilterChange(event, filterType) {
    const filter = event.target.value;

    if ( ! Array.isArray( defaultActiveFilters[filterType] ) ) {
      let updatedBoolean = activeFilters[filterType];
      if ( activeFilters[filterType] === true ) {
        updatedBoolean = undefined;
      }
      else {
        updatedBoolean = true;
      }
      setActiveFilters({
        ...activeFilters,
        [filterType]: updatedBoolean
      });
    }
    else {

      const updatedFilters = [...activeFilters[filterType]];

      if ( activeFilters[filterType].includes(filter) ) {
        updatedFilters.splice(updatedFilters.indexOf(filter), 1);
      }
      else {
        updatedFilters.push(filter);
      }
      setActiveFilters({
        ...activeFilters,
        [filterType]: updatedFilters
      });
    }
  }

  useEffect(() => {
    let updatedFilteredItems;
    if ( operatorType === "or" ) {
      updatedFilteredItems = [];
      Object.keys(defaultActiveFilters).map((filterType) => {
        if ( Array.isArray( defaultActiveFilters[filterType] ) ) {
          const tempItems = items.filter((item) => {
            return activeFilters[filterType].filter((activeFilter) => {
              return filterSections.find(section => section.type === filterType).entityMatchFunction(item, activeFilter);
            }).length > 0;
          });
          updatedFilteredItems.push(...tempItems);
        }
        /*else {
          updatedFilteredItems = updatedFilteredItems.filter((item) => {
            return filterSections.find(section => section.type === filterType).entityMatchFunction(item, activeFilters[filterType]);
          });
        }*/
      });
      updatedFilteredItems = updatedFilteredItems.filter((item, index) => {
        return updatedFilteredItems.indexOf(item) === index;
      }).sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
    }
    else {
      updatedFilteredItems = items;
      Object.keys(defaultActiveFilters).map((filterType) => {
        if ( Array.isArray( defaultActiveFilters[filterType] ) ) {
          updatedFilteredItems = updatedFilteredItems.filter((item) => {
            return activeFilters[filterType].filter((activeFilter) => {
              return filterSections.find(section => section.type === filterType).entityMatchFunction(item, activeFilter);
            }).length > 0;
          });
        }
        else {
          updatedFilteredItems = updatedFilteredItems.filter((item) => {
            return filterSections.find(section => section.type === filterType).entityMatchFunction(item, activeFilters[filterType]);
          });
        }
      });
    }
    setFilteredItems(updatedFilteredItems);
    
  }, [activeFilters]);
  
  function handleReset(event) {
    event.preventDefault();
    setActiveFilters(defaultActiveFilters);
  }

  function handleToggleAll(event, filterType) {
    event.preventDefault();
    if ( Array.isArray( defaultActiveFilters[filterType] ) ) {
      if ( activeFilters[filterType].length > 0 ) {
        setActiveFilters({
          ...activeFilters,
          [filterType]: []
        });
      }
      else {
        setActiveFilters({
          ...activeFilters,
          [filterType]: defaultActiveFilters[filterType]
        });
      }
    }
  }

  function getClassName() {
    let className = "";
    if ( filtersOpenMobile ) {
      className = "is-open";
    }
    if ( entity ) {
      className = "is-entity-view";
    }
    if ( hasMobileNav ) {
      className += " has-mobile-nav";
    }
    return className;
  }

  function getResetClassName() {
    let className = "toggle-all";
    let isHidden = true;
    Object.keys(defaultActiveFilters).forEach((filterType) => {
      if ( 
        ( ! Array.isArray( defaultActiveFilters[filterType] ) && defaultActiveFilters[filterType] !== activeFilters[filterType] ) ||
        ( defaultActiveFilters[filterType]?.length !== activeFilters[filterType]?.length )
      ) {
        isHidden = false;
      }
    });
    if ( isHidden ) {
      className += " is-hidden";
    }
    return className;
  }

  return (
    <StyledFilterControls className={getClassName()}>
      <div className="meta">
        <strong>Filter {items.length} {filterTypeLabel}</strong>
        <div className="actions">
          {activeFilters !== defaultActiveFilters && (
            <button className={getResetClassName()} type="button" onClick={(e) => handleReset(e)}>
              <span className="label">Reset</span> 
            </button>
          )}
          <div className="actions-done">
            <Button className="is-small" type="button" onClick={() => setFiltersOpenMobile(false)}>Done</Button>
          </div>
        </div>
      </div>
        <div className="filters">
          {filterSections.map((section, index) => {
            return (
              <div className="fieldset" key={index}>
                <div className="header">
                  <div className="legend">{section.name}</div>
                  {defaultActiveFilters[section.type]?.length && (
                    <button type="button" className={activeFilters[section.type]?.length < 1 ? "toggle-all is-filled" : "toggle-all" } onClick={(e) => handleToggleAll(e, section.type)}>
                      <span className="checkbox"></span>
                      <span className="label">All</span> 
                    </button>
                  )}
                </div>
                {section.filters.map((filter, index) => {
                  return (
                    <FilterToggleControl
                      key={index}
                      value={filter.value} 
                      label={filter.label}
                      count={filter.count} 
                      visibleCount={filter.visibleCount} 
                      caveat={filter.caveat}
                      handleFilterChange={handleFilterChange} 
                      activeFiltersArray={activeFilters[section.type]}  
                      filterType={section.type}
                      description={filter.hint}
                      isBoolean={section.isBoolean}
                      theme={filter.theme}
                    />
                  )
                })}
              </div>
            )
          })}
        </div>
    </StyledFilterControls>
  );
};

export default FilterControls;

const StyledFilterControls = styled.div`
  position: relative;
  background-color: inherit;
  border-radius: 1em;
  padding: 0 1.5em 1.5em;
  min-height: 100%;
  max-height: 100%;
  z-index: 5;
  @media ( max-width: 70em ) {
    position: fixed;
    top: calc(var(--navbar-height) + 43px);
    //bottom: 81px;
    bottom: 0;
    &.has-mobile-nav {
      bottom: 81px;
    }
    height: auto;
    min-height: 0;
    max-height: none;
    left: 0;
    right: 0;
    padding: 0 var(--gutter) 1.5em;
    border-radius: 0;
    z-index: 20;
    display: none;
    background-color: var(--color-black);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    &.is-open {
      transform: translate3d(0,0,0);
      display: block;
    }
  }
  .meta {
    position: sticky;
    top: 0;
    padding: 0.875em 0 0.75em;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(255,255,255,0.5);
    background-color: inherit;
    margin-bottom: 1em;
    z-index: 2;
    @media ( max-width: 70em ) {
      padding: 0;
      height: 2.625em;
    }
    strong {
      font-size: 0.875em;
      font-weight: 700;
      opacity: 0.6;
      @media ( max-width: 70em ) {
        line-height: 1;
      }
    }
    .actions {
      display: flex;
      align-items: center;
      gap: 1em;
    }
    .actions-done {
      display: none;
      @media ( max-width: 70em ) {
        display: block;
      }
    }
  }
  @media ( min-width: 60em ) and ( max-width: 70em ) {

    top: 127px;
  }

  .toggle-all {
      font-weight: 700;
      background-color: #444;
      height: 1.25em;
      padding: 0 0.5em;
      border-radius: 1em;
      padding-top: 0.0625em;
      opacity: 0.5;
      display: flex;
      gap: 0.25em;
      align-items: center;
      &.is-hidden {
        opacity: 0;
      }
      .label {
        font-size: 0.75em;
        font-weight: 700;
        line-height: 1;
      }
      .checkbox {
        position: relative;
        display: block;
        border-color: currentColor;
        border: 2px solid;
        font-size: 0.9375em;
        width: 0.875em;
        height: 0.875em;
        border-radius: 50%;
        margin-left: -0.25em;
        &::before {
          content: "";
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          border-radius: inherit;
          border: 1.5px solid #444;
        }
      }
      &.is-filled {
        .checkbox {
          background-color: currentColor;
        }
      }
    }
  .filters {
    display: grid;
    gap: 0.25em;
    padding-bottom: 1.5em;
    .fieldset:not(:last-of-type) {
      padding-bottom: 1em;
      border-bottom: 1px solid rgba(255,255,255,0.2);
      margin-bottom: 1em;
    }
    .legend {
      display: block;
      font-size: 0.875em;
      font-weight: 700;
      opacity: 0.6;
      //padding-left: 2.5em;
      margin-bottom: 0.5em;
    }
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 0.5em;
      margin-bottom: 0.75em;
      .legend {
        margin-bottom: 0;
      }
    }
  }
`;
